import React from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useFormik } from 'formik'
import { Checkbox, Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createTrackProfile, updateTrackProfile } from '../../actions/directoryBasicEducation'
import * as Yup from 'yup'



const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(256, 'Должно быть не более 256 символов'),
  full_name: Yup.string().max(256, 'Должно быть не более 256 символов'),
})

export default function ModalComponent({ data, closeModal, addMode }) {

  const dispatch = useDispatch()

  const handleCreate = (values) => {
    dispatch(createTrackProfile(values, closeModal));
  }

  const handleUpdate = (values) => {
    dispatch(updateTrackProfile(values, closeModal));
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? {
      name: '',
      full_name: '',
      isbasic: false,
      closed: false
    } : { ...data, full_name: data?.full_name ?? '' },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]


  return (
    <Modal
      open={!!data}
      onClose={() => closeModal(null)}
      showCloseIcon={false}
      closeOnOverlayClick={true}
      center
      classNames={{
        modal: styles.modal,
        modalContainer: styles.modalContainer
      }}
    >
      <>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление профиля обучения' : 'Редактирование профиля обучения'}</h2>

          <div className={styles.inputsColumn}>
            <Input
              label='Название'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
              labelStyle={{ width: '100%', maxWidth: '100%' }}
              />
            <Input
              label='Полное название'
              name='full_name'
              value={values.full_name}
              error={error('full_name')}
              onChange={handleChange}
              labelStyle={{ width: '100%', maxWidth: '100%' }}
            />
            <div className={styles.checkboxRow}>
              <Checkbox label='Это Базовый' checked={values.isbasic} value={!!values.isbasic} onChange={handleChange} name='isbasic' />
              <Checkbox label='Закрыт' checked={values.closed} value={!!values.closed} onChange={handleChange} name='closed' />
            </div>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
